import { defineMessages } from 'react-intl';

const scope = 'cb.screens.BusinessDetails';

export default defineMessages({
  noCouponsMessage: {
    id: `${scope}.noCouponsMessage`,
    defaultMessage: 'This business does not have any coupons.',
  },
});